import React, { useEffect, useState } from "react";
import DrawerGoBackComponent from "./DrawerGoBackComponent";
import { CurrentDrawerOpenType, closeDrawer } from "state/slices/RightDrawerSlice";
import { DialogOpenType, openDialog } from "state/slices/DialogSlice";
import CMRTransformSliderComponent from "./CMRTransformSliderComponent";
import { useTypedSelector } from "hooks/store";
import * as modelsData from "assets/json/models.json";
import { Button } from "@mui/material";
import { useTypedDispatch } from "hooks/store";

const DrawerBedComponent = (): JSX.Element => {
    const dispatch = useTypedDispatch();

    const position = useTypedSelector((state) => state.Scene.selectedPatientPosition);

    const [bedHeadZ, setBedHeadZ] = useState(false);

    useEffect(() => {
        if (position) {
            const modelData = modelsData.globalSettings.models.patientBed.find(
                (model) => model.name === position
            );

            console.log("Model Data:", modelData);

            setBedHeadZ(modelData?.BedHeadZ ?? false);
        } else {
            setBedHeadZ(false);
        }
    }, [position]);

    const changePatient = async (): Promise<void> => {
        dispatch(closeDrawer(CurrentDrawerOpenType.Bed));
        dispatch(openDialog({ isDialogOpen: true, type: DialogOpenType.ChangePatient }));
    };

    return (
        <section className="bedComponent">
            <article>
                <CMRTransformSliderComponent
                    title="Bed Rotate Z"
                    target="Waist"
                    property="rotation"
                    axis="z"
                    min={-20}
                    max={20}
                    step={1}
                />

                <CMRTransformSliderComponent
                    title="Bed Rotate X"
                    target="Waist"
                    property="rotation"
                    axis="x"
                    min={-20}
                    max={20}
                    step={1}
                />

                <CMRTransformSliderComponent
                    title="Bed Height"
                    target="Waist"
                    property="position"
                    axis="y"
                    min={0.4}
                    max={0.55}
                    step={0.01}
                />
            </article>
            {bedHeadZ && (
                <article>
                    <CMRTransformSliderComponent
                        title="Bed Head Z"
                        target="Center_Hinge"
                        property="rotation"
                        axis="x"
                        min={-15}
                        max={0}
                        step={1}
                    />
                </article>
            )}

            <article style={{ marginTop: "2rem" }}>
                <Button onClick={() => changePatient()} fullWidth className="btn pinkRoundedButton">
                    Change Patient
                </Button>
            </article>

            <DrawerGoBackComponent classes="onlyDesktop" type={CurrentDrawerOpenType.Bed} />
        </section>
    );
};

export default DrawerBedComponent;
